var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#C3A634"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.452 8.21812H9.87862V9.504H7.452V12.2141H8.98256C9.58838 12.2141 10.0839 12.1326 10.4698 11.9683C10.8557 11.8046 11.1583 11.5779 11.3783 11.2877C11.6032 10.9859 11.7563 10.6367 11.826 10.2668C11.9073 9.84946 11.9468 9.42512 11.9441 9C11.9468 8.57488 11.9073 8.15054 11.826 7.73325C11.7564 7.36329 11.6033 7.01411 11.3783 6.71231C11.1583 6.42206 10.8551 6.19537 10.4698 6.03169C10.0839 5.86744 9.58838 5.78588 8.98256 5.78588H7.452V8.21869V8.21812ZM5.89613 9.504H5.0625V8.21869H5.89613V4.5H9.57994C10.2606 4.5 10.8495 4.61812 11.3473 4.85269C11.8451 5.08837 12.2512 5.40956 12.5668 5.81737C12.8818 6.22462 13.1164 6.70163 13.2699 7.24781C13.4235 7.794 13.5 8.37844 13.5 9C13.5039 9.59188 13.4263 10.1815 13.2694 10.7522C13.1164 11.2978 12.8818 11.7754 12.5662 12.1826C12.2513 12.5904 11.8451 12.9116 11.3473 13.1473C10.8495 13.3824 10.26 13.5 9.57994 13.5H5.89613V9.504Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoge);
export default __webpack_public_path__ + "static/media/doge.52ef12616de89cb39ad4e94f1a43b235.svg";
export { ForwardRef as ReactComponent };